module.exports = __webpack_public_path__ + "img/arrow-forward-used.56588305.svg";